export default {
  site: {
    brandKo: "Hankuk Rubber Tech. Co., Ltd.",
    brandShort: "Hankuk Rubber",
    brandEn: "HANKUK RUBBER TECH. CO.,LTD.",
    tel: "031-434-0341",
    telLink: "tel:031-434-0341",
    email: "hkrubbert@naver.com",
    emailLink: "mailto:hkrubbert@naver.com",
    fax: "031-434-0340",
    address: "36, Okguseocheon-ro 237beon-gil, Siheung-si, Gyeonggi-do, Korea",
    established: 1975,
    experienceYears: 50,
  },
  nav: {
    links: [
      { label: "HOME", to: "/" },
      {
        label: "About Us",
        to: "/about/overview",
        sub: [
          { label: "CEO Message", to: "/about/ceo" },
          { label: "Company Overview", to: "/about/overview" },
          { label: "History", to: "/about/history" },
          { label: "Certifications", to: "/about/certifications" },
          { label: "Location", to: "/about/location" },
        ],
      },
      { label: "Business", to: "/business" },
      { label: "Products", to: "/products" },
      { label: "Technical", to: "/technical" },
      { label: "Support", to: "/support" },
      { label: "Quote", to: "/quotation" },
      { label: "Contact", to: "/contact" },
    ],
    quoteRequest: "Get a Quote",
    quoteRequestFull: "Request a Quote",
    menuOpen: "Open menu",
  },
  topbar: {
    tagline: "HANKUK RUBBER TECH · Industrial Rubber Product Manufacturer",
    tel: "TEL · 031-434-0341",
  },
  footer: {
    desc: "Hankuk Rubber Tech. Co., Ltd. develops and manufactures rubber products across diverse industries, and works as a technology-driven manufacturer that analyzes and solves the challenges our customers face.",
    sitemapTitle: "SITEMAP",
    contactTitle: "CONTACT",
    links: [
      {
        label: "About Us",
        to: "/about/overview",
        sub: [
          { label: "CEO Message", to: "/about/ceo" },
          { label: "Company Overview", to: "/about/overview" },
          { label: "History", to: "/about/history" },
          { label: "Certifications", to: "/about/certifications" },
          { label: "Location", to: "/about/location" },
        ],
      },
      { label: "Business", to: "/business" },
      { label: "Products", to: "/products" },
      { label: "Technical", to: "/technical" },
      { label: "Support", to: "/support" },
      { label: "Quote", to: "/quotation" },
      { label: "Contact", to: "/contact" },
    ],
    address: "Address",
    tel: "TEL",
    fax: "FAX",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    sitemap: "Sitemap",
    admin: "Admin",
    rights: "All rights reserved.",
  },
  comingSoon: {
    cards: {
      precision: { title: "Precision Design", desc: "Drawing analysis and prototype design" },
      molding: { title: "Compression Molding", desc: "Stable quality mass production" },
      quality: { title: "Quality Assurance", desc: "Full inspection and after-sales support" },
    },
    backHome: "Back to Home",
    contactNow: "Contact Us Now",
  },
  notFound: {
    title: "This page has not been generated",
    hint: "Tell me more about this page, so I can generate it",
  },
};